export const RouteConstants = {
  home: "/",
  login: "/login",
  privacyPolicy: "/privacy-policy",
  termsOfServices: "/terms-services",
  users:'/users',
  subscription: "/subscription",
  memoirs:"/memoirs",
  biographies:"/biographies",
  dashboard:'/dashboard'
};